import { Component, OnInit, inject } from '@angular/core';
import { Observable, finalize, takeUntil } from 'rxjs';

import {
  CustomPlaceWithPaginationDto,
  CustomResultOfPaginatedListOfCustomPlaceWithPaginationDto,
  PaginatedListOfCustomPlaceWithPaginationDto,
} from 'src/app/core/api/models';
import { CustomPlaceService } from 'src/app/core/api/services';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { CustomPlaceDto } from './../../../core/api/models/custom-place-dto';
import { GetEnumValuesDto } from './../../../core/api/models/get-enum-values-dto';
import { UpdateCustomPlaceCommand } from './../../../core/api/models/update-custom-place-command';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { PageNames } from 'src/app/configs/page-names.enum';

@Component({
    selector: 'app-custom-place',
    templateUrl: './custom-place.component.html',
    standalone: false
})
export class CustomPlaceComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.customPlace;

  /* Binding service endpoints */
  protected currentService = inject(CustomPlaceService);
  paginationApiMethodName: string = this.currentService.customPlaceGetCustomPlacesWithPagination.name;
  createGetApiMethodName: string = this.currentService.customPlaceCreateGet.name;
  auditApiMethodName: string = this.currentService.customPlaceGetCustomPlacesAudit.name;

  modelWithPagination$: Observable<PaginatedListOfCustomPlaceWithPaginationDto>;
  items$: Observable<Array<CustomPlaceWithPaginationDto>>;
  formPageConfig: FormPageConfig<CustomPlaceDto> = {};
  updateModel: UpdateCustomPlaceCommand = {};
  GeometryTypeEnumValues: GetEnumValuesDto[] = [];
  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.isAddBtnWithLoading = true;
  }

  getEnumsValues() {
    this.getEnumValuesApi('GeometryType')
      .pipe(this.basePipeOperators())
      .subscribe((values) => (this.GeometryTypeEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: ``,
        name: '',
        hasSearch: false,
        noSorting: true,
        isCheckBox: true,
      },
      { title: this.localizer.id, name: 'id', hasSearch: true },
      { title: this.localizer.title, name: 'title', hasSearch: true },
      {
        title: `${this.tableVocabs}provinceName`,
        name: 'provinceName',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}cityName`,
        name: 'cityName',
        hasSearch: true,
      },
      {
        title: this.localizer.organizationName,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}geometryType`,
        name: 'geometryType',
        hasSearch: true,
        type: 'enum',
        enumName: 'GeometryType',
      },
      // {
      //   title: `${this.tableVocabs}coordinates`,
      //   name: 'coordinates',
      //   hasSearch: true,
      // },
      {
        title: `${this.tableVocabs}isActive`,
        name: 'isActive',
        type: 'boolean',
        hasSearch: true,
      },
    ];
  }

  //#region Api

  setDefaultTableSort() {
    this.sortObject.push({ columnName: 'organizationName', sort: 1 });
  }

  //Get ById
  baseGetByIdApi(id: number): void {
    // this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .customPlaceUpdateGet({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //Delete
  // baseDeleteApi(id: number) {
  //   this.unSubs();

  //   this.pageConfig.loading = true;
  //   this.lastSelectedItemId = id;

  //   this.currentService
  //     .customPlaceDelete({ id: id })
  //     .pipe(this.basePipeOperators())
  //     .subscribe(this.baseDeleteObserver);
  // }

  deleteCustomPlaceApi(ids: number[]) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = ids;

    this.currentService
      .customPlaceDelete({ body: { ids: ids } })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.selectedIds = []))
      )
      .subscribe(this.baseGroupDeleteObserver);
  }

  //#endregion

  //#region group Deletion
  callGroupDeletion() {
    this.deleteCustomPlaceApi(this.selectedIds);
  }

  //#endregion

  onDelete(id: any, content: any, confirmByWritingText?: boolean) {
    const dialogResult = this.getConfirmDialog({
      content: content,
      isConfirmDelete: true,
      confirmByWritingText: confirmByWritingText,
    });

    dialogResult
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        if (result) {
          this.pageConfig.loading = true;
          this.selectedIds = [];
          this.selectedIds.push(id);
          this.deleteCustomPlaceApi(this.selectedIds);
        }
      });
  }
}

